import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
import _ from 'underscore';
import MapView from './MapView';
import BreadCrumbs from './BreadCrumbs';

import config from './../config';

class SveitarFelogListView extends Component {
	constructor(props) {
		super(props);

		this.url = config.apiRoot+'/sveitarfelog/';

		this.state = {}
	}

	componentDidMount() {
		this.fetchData();
	}

	componentDidUpdate(prevProps) {
		if (prevProps.match.params.id != this.props.match.params.id) {
			this.fetchData();
		}
	}

	fetchData() {
		fetch(this.url+(this.props.match.params.id ? this.props.match.params.id+'/' : ''))
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				this.setState({
					data: (json.results || json.hreppar),
					baeir: json.baeir || null,
					sveitarfelag: json.sveitarfelag ? json.sveitarfelag[0] : null,
					single: Boolean(this.props.match.params.id),
					mapData: json.baeir ? json.baeir.map((baer) => {
						if (baer.lat && baer.lng) {
							return {
								id: baer.id,
								label: baer.baejarnafn,
								//district: json.hreppur[0].nafn+', '+json.sysla[0].nafn,
								type: 'farm',
								tegund: baer.tegund ? baer.tegund.tegund : null,
								latLng: [baer.lat, baer.lng]
							};
						}
					}) : null
				});
			}.bind(this));
	}

	render() {
		return (
			<div className={'row boxes'}>

				<div className={'col col-12'}>
					<div className="column-content">
						{
							this.state.single &&
							<React.Fragment>
								<BreadCrumbs path={[
									{
										path: '/sveitarfelog/',
										title: 'Sveitarfélög'
									},
									{
										path: '',
										title: this.state.sveitarfelag.nafn
									}
								]} />
								<div className="row">
									<div className="col col-12 col-md-4">
										<h3>{this.state.sveitarfelag.nafn}</h3>
										<hr/>

										{
											this.state.single &&
											<h5>Bæir</h5>
										}

										{
											this.state.baeir &&
											<table className="table">
												<thead>
													<tr>
														<th>Titill</th><th></th>
													</tr>
												</thead>
												<tbody>
													{
														this.state.baeir.map((item, index) => <tr key={index}>
															<td><Link to={'/baer/'+item.id}>{item.baejarnafn}</Link></td>
															<td>{item.fjoldi_skjala > 0 ? (item.fjoldi_skjala === 1 ? item.fjoldi_skjala+' skjal' : item.fjoldi_skjala+' skjöl') : ''}</td>
														</tr>)
													}
												</tbody>
											</table>
										}
									</div>

									<div className={'col col-12 col-md-8'}>
										<MapView mapData={this.state.mapData} />
									</div>
								</div>
							</React.Fragment>
						}
						{
							!this.state.single &&
							<React.Fragment>
								{
									!this.state.single &&
									<h3>Sveitarfélög</h3>
								}
								<hr/>

								{
									this.state.data &&
									<table className="table table">
										<thead>
											<tr>
												<th>Titill</th>
											</tr>
										</thead>
										<tbody>
											{
												this.state.data.map((item, index) => <tr key={index}>
													<td><Link to={'/sveitarfelog/'+item.id}>{item.nafn}</Link></td>
												</tr>)
											}
										</tbody>
									</table>
								}

							</React.Fragment>

						}
					</div>
				</div>

			</div>
		);
	}
}

export default withRouter(SveitarFelogListView);



// WEBPACK FOOTER //
// ./src/components/SveitarFelogListView.js